import { Storage, Auth } from 'aws-amplify';

/**
 * S3 client specifically configured for the profiles bucket
 * This client handles file uploads to the REACT_APP_S3_PROFILES_BUCKET_NAME bucket
 * while maintaining the same interface as the default Amplify Storage
 */

/**
 * Upload a file to the profiles S3 bucket
 * @param key - The S3 key/path for the file
 * @param file - The file to upload
 * @param options - Upload options including contentType
 * @returns Promise that resolves when upload is complete
 */
export const uploadToProfilesBucket = async (
    key: string,
    file: File,
    options?: { contentType: string }
): Promise<any> => {
    try {
        // Temporarily configure Storage for the profiles bucket
        Storage.configure({
            AWSS3: {
                bucket: process.env.REACT_APP_S3_PROFILES_BUCKET_NAME,
                region: process.env.REACT_APP_S3_REGION,
            }
        });

        try {
            // Perform the upload using the profiles bucket configuration
            const result = await Storage.put(key, file, {
                contentType: options?.contentType || file.type,
                level: 'public', // Use public level for shop media
            });

            return result;

        } finally {
            // Always restore the original configuration to the default image upload bucket
            Storage.configure({
                AWSS3: {
                    bucket: process.env.REACT_APP_S3_IMAGE_UPLOAD_BUCKET_NAME,
                    region: process.env.REACT_APP_S3_REGION,
                }
            });
        }

    } catch (error) {
        // Log error for debugging
        console.error('Failed to upload to profiles bucket:', error);

        // Re-throw with more context
        if (error instanceof Error) {
            throw new Error(`Upload to profiles bucket failed: ${error.message}`);
        } else {
            throw new Error('Upload to profiles bucket failed: Unknown error');
        }
    }
};